import type { FC } from "react";
import { useState } from "react";

import HygieneUpdateModal from "@/components/modals/profil-hygiene/hygiene-update-modal";
import HygieneDropButton from "@/components/patient/hygiene-drop-button";
import type { PatientProps } from "@/components/patient/patient-profile";
import PatientProfilePart from "@/components/patient/patient-profile-part";

const PatientHygiene: FC<PatientProps> = ({ patient }) => {
  const [hygieneModalOpen, setHygieneModalOpen] = useState<
    "sports" | "diet" | "none"
  >("none");

  return (
    <PatientProfilePart title={"Hygiène de vie"}>
      <HygieneDropButton
        mode={"diet"}
        value={patient.dietComment}
        setHealthModalOpen={setHygieneModalOpen}
      />
      <HygieneDropButton
        mode={"sports"}
        value={patient.sportsComment}
        setHealthModalOpen={setHygieneModalOpen}
      />
      <HygieneUpdateModal
        hygieneModalOpen={hygieneModalOpen}
        setHygieneModalOpen={setHygieneModalOpen}
        patient={patient}
      />
    </PatientProfilePart>
  );
};

export default PatientHygiene;
